var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.487,
    height: 62.487,
    viewBox: "0 0 62.487 62.487",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-dashboard",
    "data-name": "Icon material-dashboard",
    d: "M4.5,39.215H32.272V4.5H4.5Zm0,27.772H32.272V46.158H4.5Zm34.715,0H66.987V32.272H39.215Zm0-62.487V25.329H66.987V4.5Z",
    transform: "translate(-4.5 -4.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.249e7cbdd09a9677e7ae69861990b457.svg";
export { ForwardRef as ReactComponent };